import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { createCompany } from "../../../redux/actions/CompanyActions";
import { addToCart } from "../../../redux/actions/CartActions";
import Loader from "../../../components/loader/Loader";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

// Validation schema
const validationSchema = Yup.object({
  businessAddress: Yup.string().required(
    "Le siège social de l'entreprise est requis"
  ),
});

function ImportationBusinessAddress() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        businessAddress: values.businessAddress,
      })
    );

    await dispatch(
      createCompany(
        user.token,
        {
          businessType: cart.businessType,
          businessName: cart.businessName,
          address: values.businessAddress,
          activitySector: cart.sectorActivity,
          country: cart.businessCountry,
        },
        handleCallback
      )
    );
  };

  const handleCallback = async ({ success, message, data }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/importation-type");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <Loader isLoading={submitting} />

      {/* Title Section */}
      <div className="container mt-4 mb-4 text-center">
        <h4 className="text-2xl font-semibold">
          Quelle est l'adresse du{" "}
          <span style={{ color: "#FF5500" }}>siège social</span> de votre{" "}
          {cart?.businessType}
        </h4>
      </div>

      {/* Form Section */}
      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{
            businessAddress: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, errors, touched, values }) => (
            <Form className="w-100" style={{ maxWidth: "500px" }}>
              <div className="mb-3">
                <Field
                  name="businessAddress"
                  className="form-control"
                  placeholder="Ex : Akwa - Boulevard de la République"
                  style={{ height: "50px" }}
                />
                {errors.businessAddress && touched.businessAddress && (
                  <div className="text-danger">{errors.businessAddress}</div>
                )}
              </div>

              <div className="d-flex justify-content-center mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default ImportationBusinessAddress;
